import React, { useState } from 'react';
import { useBlock } from './SiteContent';

const DEFAULT = {
  title: 'Пространство, где можно быть собой.',
  subtitle: 'психолог · Минск и онлайн',
  lead: 'Здесь можно быть разным. Растерянным, злым, уставшим, не таким как все — любым. Можно сомневаться, бояться. Без масок. Без «надо». Без страха осуждения.',
  lead_2: 'Это пространство, где строгая научная база встречается с человеческим теплом, а интеллект — с душой. Я не «исправляю». Я помогаю вам услышать себя, вернуть авторство своей жизни и найти ту точку опоры, которая всегда была внутри.',
  tagline: 'С глубоким уважением к вашей боли и вашей силе.',
  cta_primary: 'Записаться на консультацию',
  cta_secondary: 'Узнать обо мне',
};

export default function Hero() {
  const h = useBlock('hero', DEFAULT);
  const [loaded, setLoaded] = useState(false);
  return (
    <section id="top" className="relative pt-24 md:pt-28 pb-16 md:pb-20 hero-glow" data-testid="hero">
      <div className="max-w-6xl mx-auto px-5 md:px-8 grid md:grid-cols-12 gap-10 md:gap-12 items-center">
        {/* Текст */}
        <div className="reveal md:col-span-7 order-2 md:order-1">
          <div className="flex items-center gap-3 mb-5 text-[13px] tracking-[0.18em] uppercase text-wine/80">
            <span className="gold-divider" />
            <span data-testid="hero-subtitle">{h.subtitle || DEFAULT.subtitle}</span>
          </div>

          <h1
            className="font-heading text-[40px] sm:text-5xl md:text-[64px] leading-[1.04] text-ink mb-7"
            data-testid="hero-title"
          >
            {h.title || DEFAULT.title}
          </h1>

          <div className="space-y-4 text-[16px] md:text-[17px] leading-relaxed text-ink/80 max-w-[560px] mb-8">
            {h.lead && <p data-testid="hero-lead">{h.lead}</p>}
            {h.lead_2 && <p data-testid="hero-lead-2">{h.lead_2}</p>}
            {h.tagline && (
              <p className="text-ink/65 italic font-heading text-[18px]" data-testid="hero-tagline">
                {h.tagline}
              </p>
            )}
          </div>

          <div className="flex flex-wrap items-center gap-5">
            <a
              href="#contact"
              className="px-7 py-3 border border-ink text-ink hover:bg-wine hover:text-cream hover:border-wine transition-colors duration-300 text-[15px]"
              data-testid="hero-cta-record"
            >
              {h.cta_primary || DEFAULT.cta_primary}
            </a>
            <a
              href="#about"
              className="text-[14px] text-ink/65 hover:text-wine transition-colors underline-offset-4 hover:underline"
              data-testid="hero-link-about"
            >
              {h.cta_secondary || DEFAULT.cta_secondary} →
            </a>
          </div>
        </div>

        {/* Фото */}
        <div className="reveal md:col-span-5 order-1 md:order-2 flex justify-center md:justify-end">
          <div className="relative w-[280px] sm:w-[340px] md:w-full max-w-[420px] aspect-[4/5]">
            <div className="absolute -inset-2 border border-gold/40 pointer-events-none" aria-hidden />
            <div className="relative w-full h-full overflow-hidden bg-oat">
              <img
                src="/photos/svetlana.png"
                alt="Светлана Белавская, психолог"
                onLoad={() => setLoaded(true)}
                className={`w-full h-full object-cover object-[50%_30%] transition-opacity duration-700 ${loaded ? 'opacity-100' : 'opacity-0'}`}
                data-testid="hero-portrait-img"
              />
              {!loaded && (
                <div className="absolute inset-0 flex items-center justify-center font-heading text-5xl text-wine/40 bg-oat">СБ</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
